document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-menu]');

  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.classList.toggle('is-open', !open);
    });
  }

  document.querySelectorAll('[data-quantity-minus], [data-quantity-plus]').forEach((button) => {
    button.addEventListener('click', () => {
      const wrapper = button.closest('.quantity');
      const input = wrapper && wrapper.querySelector('input[type="number"]');
      if (!input) return;
      const current = Number(input.value) || 1;
      const minimum = Number(input.min) || 1;
      input.value = String(button.hasAttribute('data-quantity-plus') ? current + 1 : Math.max(minimum, current - 1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
});
